import $ from 'jquery';
import slick from 'slick-carousel';// eslint-disable-line
import LazyLoad from 'vanilla-lazyload';

(() => {

  $('html,body').animate({ scrollTop: 0 }, '1');

  new LazyLoad();

  $(document).on(
    'opening',
    '.modal__common',
    function (e) {
      unSlick();
      setSlick(e.currentTarget);
    }.bind(this),
  );

  $(document).on(
    'opened',
    '.modal__common',
    function (e) {
      unSlick();
      setSlick(e.currentTarget);
    }.bind(this),
  );

  function unSlick() {
    $('.modal__common').each(function (index, el) {
      var mainSlick = $(el).find('.modal__commonContent');
      var langSlick = $(el).find('.modal__commonContentLang');
      if (mainSlick.hasClass('slick-initialized')) {
        mainSlick.slick('unslick');
      }
      if (langSlick.hasClass('slick-initialized')) {
        langSlick.slick('unslick');
      }
    });
  }

  function setSlick(target) {
    // $('.modal__common').each(function(index, el) {

    $(target).find('.modal__commonContent').slick({
      fade: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: false,
      centerMode: false,
      arrows: false,
      dots: false,
      swipe:false
    });

    $(target).find('.modal__commonContentLang').slick({
      slidesToShow: 3,
      // slidesToScroll: 3,
      asNavFor: $(target).find('.modal__commonContent'),
      dots: false,
      centerMode: false,
      adaptiveHeight: false,
      focusOnSelect: true,
      swipe:false
    });
  // });
  }

  $('.btn-ga').on('click', function () {
    let name = $(this).data('name');
    let utm_campaign
    if (get_param('utm_campaign')) {
      utm_campaign = get_param('utm_campaign')
    } else {
      utm_campaign = "none"
    }
    ga('send', 'event', 'shoesBtn', name, utm_campaign)
    // console.log(utm_campaign)
  });

  function get_param(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
})();
